<mat-form-field class="w-full" >
  <mat-label>{{label() | translate}}</mat-label>
  <input type="text" placeholder="{{placeholder() | translate}}" matInput [formControl]="control()!" [required]="required()!" [matAutocomplete]="autoGroup">
  <mat-autocomplete #autoGroup="matAutocomplete" [displayWith]="displayFn">
    <ng-container>
      <div class="btn-paginate"><mat-icon [ngClass]="{ 'no-pointer': currentPage === 0 }" (click)="minus()">keyboard_arrow_left</mat-icon><mat-icon [ngClass]="{ 'no-pointer': isLastItems }" (click)="plus()">keyboard_arrow_right</mat-icon></div>
      @for (group of groupOptions; track group) {
        <mat-optgroup [label]="group.title">
          @for (option of group.colors; track option) {
            <mat-option [value]="{ color:option }">
              {{ getLabel(option) }}
            </mat-option>
          }
        </mat-optgroup>
      }
    </ng-container>
  </mat-autocomplete>
  <mat-error>
    {{error() | translate}}
  </mat-error>

</mat-form-field>